import { render, staticRenderFns } from "./CamMessageSettings.vue?vue&type=template&id=f36d1c94&scoped=true"
import script from "./CamMessageSettings.vue?vue&type=script&lang=ts"
export * from "./CamMessageSettings.vue?vue&type=script&lang=ts"
import style0 from "./CamMessageSettings.vue?vue&type=style&index=0&id=f36d1c94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36d1c94",
  null
  
)

export default component.exports